export default "__VITE_ASSET__B3_S1ssa__"